import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const iconBgColors = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-600',
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-600',
];

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">分类浏览</h2>
          <p className="text-sm text-foreground-500 mt-1">按分类找到你喜欢的韩国漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat, idx) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${iconBgColors[idx]} transition-transform group-hover:scale-110`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              {cat.count > 0 && (
                <span className="text-xs text-foreground-400">{cat.count}部作品</span>
              )}
              {cat.count === 0 && (
                <span className="text-xs text-foreground-400">即将上线</span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}